/**
 * Persists 360 Assigned To values across tab navigation (360 list routes unmount
 * when switching Queuing / Web Search / Investigating / etc.).
 */

type Listener = (workflowRunUuid: string, assigneeName: string) => void;

type AssigneeOverlayEntry = {
  assigneeName: string;
  updatedAt: number;
};

const ASSIGNEE_OVERLAY_TTL_MS = 60 * 1000;
const assignees = new Map<string, AssigneeOverlayEntry>();
const listeners = new Set<Listener>();

export const threeSixtyAssigneeOverlay = {
  get(workflowRunUuid: string, lockedBy?: string | null): string {
    const normalizedLockedBy = (lockedBy ?? "").trim();
    if (normalizedLockedBy) {
      return normalizedLockedBy;
    }
    const entry = assignees.get(workflowRunUuid);
    if (!entry) {
      return "";
    }
    if (Date.now() - entry.updatedAt > ASSIGNEE_OVERLAY_TTL_MS) {
      assignees.delete(workflowRunUuid);
      return "";
    }
    return entry.assigneeName;
  },

  set(workflowRunUuid: string, assigneeName: string): void {
    assignees.set(workflowRunUuid, {
      assigneeName,
      updatedAt: Date.now(),
    });
    listeners.forEach((listener) => listener(workflowRunUuid, assigneeName));
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  clearForTests(): void {
    assignees.clear();
  },
};
